/**
 * Types
 */

export const Types = {
  SET_ONBOARDING_PAGES: "onboarding/SET_ONBOARDING_PAGES",
  SET_ONBOARDING_PAGE_CONCLUDED: "onboarding/SET_ONBOARDING_PAGE_CONCLUDED",
  SET_DYNAMIC_QUESTIONS: "onboarding/SET_DYNAMIC_QUESTIONS",
  SET_ANSWERS_INTEREST: "onboarding/SET_ANSWERS_INTEREST" 
}